export default "__VITE_ASSET__0bnwgaVh__"